<template>
  <div class="main">
    <Header
      :show="true"
      title="修改盘点信息"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        left-icon="info-o"
        color="#ed6a0c"
        background="#FFFBE8"
        text="注意：罐口物料非常重要，请谨慎修改"
      />
      <van-form ref="update" @submit="submit">
        <van-field
          v-model.trim="listQuery.name"
          label="名称"
          placeholder="请输入物料名称"
          required
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          clickable
          name="picker"
          :value="listQuery.material"
          label="物料"
          placeholder="请选择物料"
          required
          @click="material.show = true"
          :rules="[{ required: true, message: '' }]"
        />
        <van-popup v-model="material.show" position="bottom">
          <van-picker
            show-toolbar
            :columns="material.columns"
            @confirm="handleMaterialSelect"
            @cancel="material.show = false"
          />
        </van-popup>
        <van-field
          v-model.trim="listQuery.totalCapacity"
          label="额定容量"
          placeholder="请输入额定容量"
          required
          :rules="[{ validator: validCheckNumber, message: '' }]"
        >
          <template #button> 吨 </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.lowerCapacity"
          label="灌料阈值"
          placeholder="请输入灌料阈值"
          required
          :rules="[{ validator: validNumber, message: '' }]"
        >
          <template #button> 吨 </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.remark"
          rows="2"
          autosize
          label="说明"
          type="textarea"
          maxlength="100"
          placeholder="请输入罐口说明"
          show-word-limit
        />
        <div style="margin: 0.6rem 1rem" v-if="checkPermission([132])">
          <van-button round block type="info" native-type="submit">
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import {
  isUserName,
  isPassword,
  isChinese,
  isPhone,
  isEmail,
} from "@/utils/validate.js";
import { getList as getMaterialList } from "@/api/material.js";
import { updateConfigOne } from "@/api/port.js";

export default {
  name: "ServiceSystemMaterialPortUpdate",
  components: {
    Header,
    Footer,
  },
  inject: ["reload"],
  data() {
    return {
      isLoading: false,
      loading: false,
      listQuery: {
        serial: "",
        name: "",
        material: "",
        totalCapacity: 0,
        lowerCapacity: 0,
        remark: "",
      },
      material: {
        show: false,
        columns: [],
      },
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {
    this.handleGetMaterialList();
  },
  beforeMount() {},
  mounted() {
    this.listQuery = this.$route.query;
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
      // console.log('dashboard-left')
    },
    handleClickRight() {
      this.$refs.update.submit();
    },
    submit() {
      Dialog.confirm({
        title: "确认更新罐口设定？",
        message: "罐口号：" + this.listQuery.serial + "号口",
      })
        .then(() => {
          this.loading = true;
          const data = {
            id: parseInt(this.listQuery.serial),
            name: this.listQuery.name,
            materialName: this.listQuery.material,
            totalCapacity: parseFloat(this.listQuery.totalCapacity),
            lowerCapacity: parseFloat(this.listQuery.lowerCapacity),
            remark: this.listQuery.remark,
          };
          updateConfigOne(data)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "更新罐口",
                  data.message
                )
              ) {
                this.$router.push({ path: "/service/project/port", query: {} });
              }
              this.loading = false;
            })
            .catch(function (error) {
              this.loading = false;
              console.error(error);
            });
        })
        .catch(() => {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "更新罐口",
            "取消"
          );
        });
    },
    handleGetMaterialList() {
      const data = {
        page: 1,
        limit: 10000,
      };
      getMaterialList(data)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            const items = data.data.items;
            this.material.columns = [];
            for (let i = 0; i < items.length; i++) {
              this.material.columns.push(items[i].name);
            }
          }
        })
        .catch(function (error) {
          console.error(error);
        });
    },
    handleMaterialSelect(value) {
      this.listQuery.material = value;
      this.material.show = false;
    },
    validName(value) {
      return new Promise((resolve) => {
        const result = isChinese(value, 2, 20);
        if (result === true) {
          resolve(true);
        } else {
          showPhoneAlarm(true, "toast", null, 2000, null, result, null);
          resolve(false);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-field__control:read-only {
  color: #999;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
